import { props, resolveObject, state } from 'cerebral/tags'
import { unset, when } from 'cerebral/operators'
import createSnackbar from 'modules/App/factories/createSnackbar'
import setCurrentDetailedFile from 'modules/Media/chains/setCurrentDetailedFile'

const getFileList = ({ props, state }) => {
  const currentNodeId = state.get('node.selectedNode.id')
  return {
    fileList: props.payload.medias.filter(
      media =>
        state.get(`media.files.${media.id}`) &&
        (!currentNodeId ||
          state.get(`media.files.${media.id}.node.id`) === currentNodeId)
    )
  }
}

const markAsRemoved = ({ props, state }) => {
  props.fileList.forEach(file =>
    state.set(`media.files.${file.id}.removed`, true)
  )
}

const deselectFiles = ({ props, state }) => {
  props.fileList.forEach(file => {
    const selectedFiles = state.get('media.selectedFiles') || []
    state.set(`media.files.${file.id}.selected`, false)

    const index = selectedFiles.indexOf(`${file.id}`)
    if (selectedFiles.length && index > -1)
      state.splice(`media.selectedFiles`, index, 1)
  })
}

export default [
  getFileList,
  markAsRemoved,
  deselectFiles,
  ({ state, path, props }) => {
    const currentFile = state.get('media.currentFile')
    return !state.get('media.selectedFiles').length
      ? path.nothingSelected()
      : props.payload.medias.findIndex(
          file => `media.files.${file.id}` === currentFile
        ) > -1
        ? path.updateTagMenu({ nextIndex: 0 })
        : path.doNothing()
  },
  {
    updateTagMenu: [...setCurrentDetailedFile],
    nothingSelected: [unset(state`media.currentFile`)],
    doNothing: []
  },
  when(props`fileList`, fileList => fileList.length > 0),
  {
    true: [
      ({ props }) => ({ fileCount: props.fileList.length }),
      createSnackbar(
        resolveObject({
          key: 'bms.media.event.filesRemoved',
          params: resolveObject({ count: props`fileCount` })
        }),
        'error'
      )
    ],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Socket/chains/removeFilesInView.js